import React, { useEffect, useRef } from "react";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Avatar from "@mui/joy/Avatar";
import Sheet from "@mui/joy/Sheet";
import Chip from "@mui/joy/Chip";
import Button from "@mui/joy/Button";
import CajaTextoGrupal from "./cajatextogrupal";
import MensajeChatAmigo from "../partesdelchat/mensajechatamigo";
import MensajeChatCuenta from "../partesdelchat/mensajechatcuenta";

export default function ContenidoChatGrupal({ datoschat }) {
  /* Se desplaza hasta el ultimo mensaje */

  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [datoschat.chat]); // Esto se activará cada vez que la conversación cambie

  /* Se desplaza hasta el ultimo mensaje */

  return (
    <div>
      <Sheet sx={{ height: "100%" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              padding: 2,
              marginLeft: { md: 10, xs: 0 },
              marginRight: { md: 10, xs: 2 },
              marginTop: 3,
            }}
          >
            {datoschat.chat
              ? datoschat.chat.map((x, index) => {
                  if (datoschat.usuarioprincipal === x.id_usuario)
                    return (
                      <MensajeChatCuenta
                        foto_cuenta={x.foto_de_perfil}
                        mensaje_chat_cuenta={x.mensaje}
                        key={index}
                      />
                    );
                  else
                    return (
                      <MensajeChatAmigo
                        foto_amigo={x.foto_de_perfil}
                        mensaje_chat_amigo={x.mensaje}
                        key={index}
                      />
                    );
                })
              : null}
            <div ref={messagesEndRef} />{" "}
            {/* Este es el contenedor para el scroll */}
          </Box>
          <Box
            sx={{
              margin: { md: 10, xs: 0 },
              marginTop: 0,
            }}
          >
            <CajaTextoGrupal />
          </Box>
        </Box>
      </Sheet>
    </div>
  );
}
